/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetRegistry200ResponseData } from './GetRegistry200ResponseData'
import {
  GetRegistry200ResponseDataFromJSON,
  GetRegistry200ResponseDataFromJSONTyped,
  GetRegistry200ResponseDataToJSON,
} from './GetRegistry200ResponseData'

/**
 *
 * @export
 * @interface GetRegistry200Response
 */
export interface GetRegistry200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetRegistry200Response
   */
  status: boolean
  /**
   *
   * @type {GetRegistry200ResponseData}
   * @memberof GetRegistry200Response
   */
  data: GetRegistry200ResponseData
}

/**
 * Check if a given object implements the GetRegistry200Response interface.
 */
export function instanceOfGetRegistry200Response(
  value: object
): value is GetRegistry200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetRegistry200ResponseFromJSON(
  json: any
): GetRegistry200Response {
  return GetRegistry200ResponseFromJSONTyped(json, false)
}

export function GetRegistry200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRegistry200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetRegistry200ResponseDataFromJSON(json['data']),
  }
}

export function GetRegistry200ResponseToJSON(
  value?: GetRegistry200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetRegistry200ResponseDataToJSON(value['data']),
  }
}
